import { DepartmentBasic } from 'src/app/models/helpbutton-models/helpbutton-department-basic.model';

export class AssistanceBasic {

    private alreadyInSitu: boolean;
    private assigned: boolean;
    private assistanceEmployeeImage: string;
    private assistanceEmployeeName: string;
    private assistanceRoomName: string;
    private assistanceType: string;
    private creationDate: number;
    private customerComments: string;
    private customerEvaluation: string;
    private customerName: string;
    private dateMillis: number;
    private endDate: number;
    private inSituDate: number;
    private internalId: string;
    private owner: boolean;
    private requestStatus: string;
    private sectionDto: DepartmentBasic;
    private staffComments: string;
    private timeUntilAcceptance: number;
    private totalAssistanceTime: number;

    constructor(alreadyInSitu?: boolean, assigned?: boolean, assistanceEmployeeImage?: string, assistanceEmployeeName?: string, assistanceRoomName?: string, assistanceType?: string, creationDate?: number, customerComments?: string, customerEvaluation?: string, customerName?: string, dateMillis?: number, endDate?: number, inSituDate?: number, internalId?: string, owner?: boolean, requestStatus?: string, sectionDto?: DepartmentBasic, staffComments?: string, timeUntilAcceptance?: number, totalAssistanceTime?: number) {
        this.alreadyInSitu = alreadyInSitu;
        this.assigned = assigned;
        this.assistanceEmployeeImage = assistanceEmployeeImage;
        this.assistanceEmployeeName = assistanceEmployeeName;
        this.assistanceRoomName = assistanceRoomName;
        this.assistanceType = assistanceType;
        this.creationDate = creationDate;
        this.customerComments = customerComments;
        this.customerEvaluation = customerEvaluation;
        this.customerName = customerName;
        this.dateMillis = dateMillis;
        this.endDate = endDate;
        this.inSituDate = inSituDate;
        this.internalId = internalId;
        this.owner = owner;
        this.requestStatus = requestStatus;
        this.sectionDto = sectionDto;
        this.staffComments = staffComments;
        this.timeUntilAcceptance = timeUntilAcceptance;
        this.totalAssistanceTime = totalAssistanceTime;
    }

    public get AlreadyInSitu() {
        return this.alreadyInSitu;
    }
    public get Assigned() {
        return this.assigned;
    }
    public get AssistanceEmployeeImage() {
        return this.assistanceEmployeeImage;
    }
    public get AssistanceEmployeeName() {
        return this.assistanceEmployeeName;
    }
    public get AssistanceRoomName() {
        return this.assistanceRoomName;
    }
    public get AssistanceType() {
        return this.assistanceType;
    }
    public get CreationDate() {
        return this.creationDate;
    }
    public get CustomerComments() {
        return this.customerComments;
    }
    public get CustomerEvaluation() {
        return this.customerEvaluation;
    }
    public get CustomerName() {
        return this.customerName;
    }
    public get DateMillis() {
        return this.dateMillis;
    }
    public get EndDate() {
        return this.endDate;
    }
    public get InSituDate() {
        return this.inSituDate;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Owner() {
        return this.owner;
    }
    public get RequestStatus() {
        return this.requestStatus;
    }
    public get SectionDto() {
        return this.sectionDto;
    }
    public get StaffComments() {
        return this.staffComments;
    }
    public get TimeUntilAcceptance() {
        return this.timeUntilAcceptance;
    }
    public get TotalAssistanceTime() {
        return this.totalAssistanceTime;
    }
    public set AlreadyInSitu(alreadyInSitu) {
        this.alreadyInSitu = alreadyInSitu;
    }
    public set Assigned(assigned) {
        this.assigned = assigned;
    }
    public set AssistanceEmployeeImage(assistanceEmployeeImage) {
        this.assistanceEmployeeImage = assistanceEmployeeImage;
    }
    public set AssistanceEmployeeName(assistanceEmployeeName) {
        this.assistanceEmployeeName = assistanceEmployeeName;
    }
    public set AssistanceRoomName(assistanceRoomName) {
        this.assistanceRoomName = assistanceRoomName;
    }
    public set AssistanceType(assistanceType) {
        this.assistanceType = assistanceType;
    }
    public set CreationDate(creationDate) {
        this.creationDate = creationDate;
    }
    public set CustomerComments(customerComments) {
        this.customerComments = customerComments;
    }
    public set CustomerEvaluation(customerEvaluation) {
        this.customerEvaluation = customerEvaluation;
    }
    public set CustomerName(customerName) {
        this.customerName = customerName;
    }
    public set DateMillis(dateMillis) {
        this.dateMillis = dateMillis;
    }
    public set EndDate(endDate) {
        this.endDate = endDate;
    }
    public set InSituDate(inSituDate) {
        this.inSituDate = inSituDate;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Owner(owner) {
        this.owner = owner;
    }
    public set RequestStatus(requestStatus) {
        this.requestStatus = requestStatus;
    }
    public set SectionDto(sectionDto) {
        this.sectionDto = sectionDto;
    }
    public set StaffComments(staffComments) {
        this.staffComments = staffComments;
    }
    public set TimeUntilAcceptance(timeUntilAcceptance) {
        this.timeUntilAcceptance = timeUntilAcceptance;
    }
    public set TotalAssistanceTime(totalAssistanceTime) {
        this.totalAssistanceTime = totalAssistanceTime;
    }
}
